import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { updateShipmentConfiguration } from '../../store/csw/csw.actions';
import Global from '../../store/global-selectors';

export const useDriverTipState = (fulfillmentPlanId, onConfigurationChange) => {
  const sellerCurrencyCode = useSelector(Global.selectSellerDefaultCurrency) || 'USD';

  const dispatch = useDispatch();

  const onDriverTipChange = useCallback(
    (newDriverTipValue) => {
      dispatch(
        updateShipmentConfiguration(fulfillmentPlanId, {
          driverTip: { value: newDriverTipValue, code: sellerCurrencyCode },
        }),
      );
      onConfigurationChange({
        driverTip: { value: newDriverTipValue, code: sellerCurrencyCode },
      });
    },
    [dispatch, fulfillmentPlanId, sellerCurrencyCode, onConfigurationChange],
  );

  return {
    onDriverTipChange,
  };
};
